var _line, _rect, _rect2, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 402,
    viewBox: "0 0 51 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 1,
    x2: 27,
    y2: 395,
    stroke: "#344054",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#1D2939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 18,
    fill: "#FD853A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 177,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 177,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#1D2939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 201,
    r: 18,
    fill: "#1D2939"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 353,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 353,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#1D2939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 377,
    r: 18,
    fill: "#FD853A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationCenterIcon);
export default __webpack_public_path__ + "static/media/educationCenterIcon.f517ef191181393466ed144901e317d5.svg";
export { ForwardRef as ReactComponent };